import axios from "axios";
import qs from "qs";

// api + "/finproinfo/" + id +"/findall"

import { api } from "@/plugins/util";

/**
 * 部门列表显示
 *
 */
export function applyList(pageNum) {
    return axios.get(api + "/directory/findallByDept", {
        params: {
            pageNum
        }
    });
}
/**
 * 子列表显示
 *
 */
export function childList(deptid) {
    return axios.get(api + "/directory/findDirByDept", {
        params: {
            deptid
        }
    });
}
/**
 * 数据列表显示
 *
 */
export function dataList() {
    return axios.get(api + "/directory/findallByZttype", {
        params: {

        }
    });
}
/**
 * 数据子列表显示
 *
 */
export function childdataList(dir) {
    return axios.get(api + "/directory/findDirByZttype", {
        params: {
            dir
        }
    });
}
